import { useQuery } from "react-query";
import http from "infra/http";
import URL from "core/resources/urls";

const useGetDestinatarios = () => {
  return useQuery({
    queryKey: [URL.CONFIGURACAO_NOTIFICACOES.OBTER_DESTINATARIOS],
    queryFn: async () => {
      const { data } = await http.get<any, any>(URL.CONFIGURACAO_NOTIFICACOES.OBTER_DESTINATARIOS);
      return data;
    },
    keepPreviousData: true,
  });
};

export default useGetDestinatarios;
